import { useEditorialTeamDelete } from '@/module/Author/EditorialTeam';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface EditorialTeamDeleteButtonProps {
  editorialTeamId: Id;
}

export function EditorialTeamDeleteButton({ editorialTeamId }: EditorialTeamDeleteButtonProps) {
  const mutation = useEditorialTeamDelete(editorialTeamId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
